import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { chartRows, chartValue, daysOutLabel, type ChartData } from './registration-chart-data'

export function RegistrationChartTable({ data }: { data: ChartData }) {
  return (
    <div className="max-h-[200px] overflow-y-auto">
      <Table className="max-w-md" aria-label="Places held by days before the event">
        <TableHeader>
          <TableRow>
            <TableHead className="h-9">Days before start</TableHead>
            <TableHead className="h-9 text-right">{data.currentLabel}</TableHead>
            {data.previous && (
              <TableHead className="h-9 text-right">{data.previousLabel}</TableHead>
            )}
          </TableRow>
        </TableHeader>
        <TableBody>
          {chartRows(data).map((row) => (
            <TableRow key={row.day} className="h-9">
              <TableCell className="py-0">
                {daysOutLabel(row.day)}
                {row.day === data.todayDay && (
                  <>
                    {' '}
                    <span className="ml-2 text-caption text-muted-foreground">Today</span>
                  </>
                )}
              </TableCell>
              <TableCell className="py-0 text-right tabular-nums">
                {chartValue(row.current)}
              </TableCell>
              {data.previous && (
                <TableCell className="py-0 text-right tabular-nums">
                  {chartValue(row.previous)}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
